import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.734 5a.833.833 0 0 0 0 1.667h13.333a.833.833 0 0 0 0-1.667H3.734Zm5 9.167c0 .46.373.833.833.833h1.667a.833.833 0 1 0 0-1.667H9.567a.833.833 0 0 0-.833.834Zm-2.5-3.334a.833.833 0 0 1 0-1.666h8.333a.833.833 0 0 1 0 1.666H6.234Z" fill="currentColor" />' }
  })
);